import React from 'react';
import techImg from '../assets/technician.jpg'; // optionnel

const importImage = (path) => {
  try {
    return require(`../assets/${path}`);
  } catch {
    return "https://via.placeholder.com/400x300?text=Image+à+venir";
  }
};

export default function About() {

  const images = [
     "equipe.jpeg",
    "equipe2.jpeg",
    "equipe3.jpeg",
    "equipe4.jpeg",
    "equipe5.jpeg",
  ];
  return (
    <section id="about" className="about container">
      
        <div>
          <h1>À propos de nous</h1>
          <p>
            Nous sommes une équipe de techniciens qualifiés offrant des interventions rapides et soignées.
            Des années d'expérience au service des particuliers, copropriétés et entreprises.
          </p>
        
              <h2>Nos engagements</h2>
              <ul>
                <li>Respect des délais et de la confidentialité</li>
                <li>Produits écologiques et biodégradables</li>
                <li>Équipe sérieuse, formée et disponible</li>
                <li>Intervention rapide à Marseille et dans les alentours</li>
              </ul>
              <h2>📍 Zone d'intervention</h2>
              <ul>
                <li><strong>Marseille et sa métropole</strong></li>
                <li>(Aix-en-Provence, Vitrolles, Martigues, Aubagne, Istres, etc...)</li>
                
              </ul>
              

        </div>
        <div className="gallery">
          {images.map((file, index) => (
            <div className="gallery-item" key={index}>
              <img
                src={importImage(file)}
                alt={`Réalisation ${index + 1}`}
                loading="lazy"
              />
            </div>
          ))}
        </div>
       
      
    </section>
  );
}
